/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Constants } from '../../../core/Constants';
import { IExample } from '../../../core/models/common/IExample';
import { Oas20Definitions } from '../models/Oas20Definitions';
import { Oas20Headers } from '../models/Oas20Headers';
import { Oas20Items } from '../models/Oas20Items';
import { Oas20ParameterDefinitions } from '../models/Oas20ParameterDefinitions';
import { Oas20ResponseDefinitions } from '../models/Oas20ResponseDefinitions';
import { Oas20Scopes } from '../models/Oas20Scopes';
import { Oas20SecurityDefinitions } from '../models/Oas20SecurityDefinitions';
import { OasNodePathVisitor } from '../../visitors/OasNodePathVisitor';
import { IOas20Visitor } from './IOas20Visitor';
import { NodePath } from '../../../core/models/NodePath';

/**
 * Constructor.
 * @class
 * @extends OasNodePathVisitor
 * @author eric.wittmann@gmail.com
 */
export class Oas20NodePathVisitor extends OasNodePathVisitor implements IOas20Visitor {
    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitItems(io.apicurio.datamodels.openapi.v2.models.Oas20Items)
     * @param {Oas20Items} node
     */
    public visitItems(node : Oas20Items) {
        this.path.prependSegment(Constants.PROP_ITEMS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitScopes(io.apicurio.datamodels.openapi.v2.models.Oas20Scopes)
     * @param {Oas20Scopes} node
     */
    public visitScopes(node : Oas20Scopes) {
        this.path.prependSegment(Constants.PROP_SCOPES, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitSecurityDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20SecurityDefinitions)
     * @param {Oas20SecurityDefinitions} node
     */
    public visitSecurityDefinitions(node : Oas20SecurityDefinitions) {
        this.path.prependSegment(Constants.PROP_SECURITY_DEFINITIONS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20Definitions)
     * @param {Oas20Definitions} node
     */
    public visitDefinitions(node : Oas20Definitions) {
        this.path.prependSegment(Constants.PROP_DEFINITIONS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitParameterDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20ParameterDefinitions)
     * @param {Oas20ParameterDefinitions} node
     */
    public visitParameterDefinitions(node : Oas20ParameterDefinitions) {
        this.path.prependSegment(Constants.PROP_PARAMETERS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitExample(io.apicurio.datamodels.core.models.common.IExample)
     * @param {*} node
     */
    public visitExample(node : IExample) {
        this.path.prependSegment(Constants.PROP_EXAMPLES, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitHeaders(io.apicurio.datamodels.openapi.v2.models.Oas20Headers)
     * @param {Oas20Headers} node
     */
    public visitHeaders(node : Oas20Headers) {
        this.path.prependSegment(Constants.PROP_HEADERS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitResponseDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20ResponseDefinitions)
     * @param {Oas20ResponseDefinitions} node
     */
    public visitResponseDefinitions(node : Oas20ResponseDefinitions) {
        this.path.prependSegment(Constants.PROP_RESPONSES, false);
    }
}
Oas20NodePathVisitor["__class"] = "io.apicurio.datamodels.openapi.v2.visitors.Oas20NodePathVisitor";
Oas20NodePathVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




